export function getVirtualRange({
  itemCount,
  scrollTop,
  itemHeight,
  viewportHeight,
  overscan = 0,
}) {
  const count = Math.max(0, itemCount);
  const totalHeight = count * itemHeight;

  if (count === 0 || itemHeight <= 0 || viewportHeight <= 0) {
    return { startIndex: 0, endIndex: 0, totalHeight };
  }

  const firstVisibleIndex = Math.min(count - 1, Math.floor(Math.max(0, scrollTop) / itemHeight));
  const visibleItemCount = Math.ceil(viewportHeight / itemHeight);
  const startIndex = Math.max(0, firstVisibleIndex - overscan);
  const endIndex = Math.min(count, firstVisibleIndex + visibleItemCount + overscan);

  return { startIndex, endIndex, totalHeight };
}
